export default class VideoItem {
    static init(): void {
        const videoItems = document.querySelectorAll<HTMLElement>('[data-video-item]');

        if (videoItems.length > 0) {
            videoItems.forEach((videoItem) => {
                const videoButton = videoItem.querySelector<HTMLElement>('[data-video-button]');

                if (videoButton) {
                    videoButton.addEventListener('click', (e: Event) => {
                        e.preventDefault();
                        videoItem.classList.add('is-active');
                        this.videoPlay(videoItem);
                    });
                }
            });
        }
    }

    private static videoPlay(wrapper: HTMLElement): void {
        const video = wrapper.querySelector<HTMLVideoElement>('video');
        const iframe = wrapper.querySelector<HTMLIFrameElement>('iframe');

        if (video) {
            const src = video.dataset.video;
            if (src) {
                video.setAttribute('src', src);
                video.play();
            }
        } else if (iframe) {
            const src = iframe.dataset.video;
            if (src) {
                iframe.setAttribute('src', src);
            }
        }
    }
}
